import { render, staticRenderFns } from "./ElibraryBukuView.vue?vue&type=template&id=0b951463&scoped=true"
import script from "./ElibraryBukuView.vue?vue&type=script&lang=js"
export * from "./ElibraryBukuView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b951463",
  null
  
)

export default component.exports